import { api } from '../index';
import { objectToFormData } from '@/api/util';

const prefix = '/api/receipt/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiIndexForPayment(param) {
	return api.post(prefix + 'indexForPayment', param);
}

export function apiSelectArList(param) {
	return api.post(prefix + 'selectArList', param);
}

export function apiSelectArHistory(param) {
	return api.post(prefix + 'selectArHistory', param);
}

export function apiAddCart(param) {
	return api.post(prefix + 'addCart', param);
}

export function apiRemoveCart(param) {
	return api.post(prefix + 'removeCart', param);
}

export function apiProcessPayment(param) {
	return api.post(prefix + 'processPayment', param);
}

export function apiSelectReceiptItemList(param) {
	return api.post(prefix + 'selectReceiptItemList', param);
}

export function apiSelectReceiptInvoiceList(param) {
	return api.post(prefix + 'selectReceiptInvoiceList', param);
}

export function apiSelectReceiptItemListForBounce(param) {
	return api.post(prefix + 'selectReceiptItemListForBounce', param);
}

export function apiBounceCheck(param) {
	return api.post(prefix + 'bounceCheck', param);
}

export function apiSelectReceiptReverseList(param) {
	return api.post(prefix + 'selectReceiptReverseList', param);
}

export function apiReverseReceipt(param) {
	return api.post(prefix + 'reverseReceipt', param);
}

export function apiUpdatePostCheckDate(param) {
	return api.post(prefix + 'updatePostCheckDate', param);
}

export function apiUpdatePostCheckValidity(param) {
	return api.post(prefix + 'updatePostCheckValidity', param);
}

export function apiUpdateCheckNo(param) {
	return api.post(prefix + 'updateCheckNo', param);
}

export function apiUpdateReceiptMethod(param) {
	return api.post(prefix + 'updateReceiptMethod', param);
}

export function apiUpdateReceiptRemark(param) {
	return api.post(prefix + 'updateReceiptRemark', param);
}

export function apiBounceList(param) {
	return api.post(prefix + 'bounceList', param);
}

export function apiBounceDate(receipt_item_no, param) {
	return api.put(prefix + 'bounce-date/' + receipt_item_no, objectToFormData(param));
}

// export function apiSelectInvoiceItemList(param) {
// 	return api.post(prefix + 'selectInvoiceItemList', param);
// }

// export function apiSelectInvoiceHistoryItemList(param) {
// 	return api.post(prefix + 'selectInvoiceHistoryItemList', param);
// }

// export function apiInsertInvoice(param) {
// 	param.mode = 'insert';
// 	return apiSubmitInvoice(param);
// 	//return api.post(prefix + 'submitInvoice', param);
// }

// export function apiUpdateInvoice(param, status_changed) {
// 	param.mode = 'update';
// 	if (status_changed) param.status_changed_yn = 'Y';
// 	//console.log(param);
// 	return apiSubmitInvoice(param);
// 	//return api.post(prefix + 'submitUser', param);
// }

// // export function apiDeleteUser(param) {
// // 	param.mode = 'delete';
// // 	return api.post(prefix + 'submitUser', param);
// // }

// function apiSubmitInvoice(param) {
// 	return api.post(prefix + 'submitInvoice', param);
// }

// export function apiSubmitInvoiceAfterBoxing(param, mode) {
// 	if (mode == 'add') param.mode = 'insert';
// 	else param.mode = 'update';
// 	return api.post(prefix + 'submitInvoiceAfterBoxing', param);
// }

// export function apiPrintPickingTicket(param) {
// 	return api.post(prefix + 'printPickingTicket', param);
// }

// export function apiCompletePacking(param) {
// 	return api.post(prefix + 'completePacking', param);
// }

// export function apiCancelPacking(param) {
// 	return api.post(prefix + 'cancelPacking', param);
// }

// export function apiAdjustBackOrderItems(param) {
// 	return api.post(prefix + 'adjustBackOrderItems', param);
// }

// export function apiSelectBackOrderItemList(param) {
// 	return api.post(prefix + 'selectBackOrderItemList', param);
// }

// export function apiTest() {
// 	return api.get('/test');
// }
